var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SmartCheckpoint } from './types';
import { welcomeMessage, smartChatMembers } from '../../utils';
import { Status } from '@lendi/lala-react';
export var initialSmartChatState = {
    messages: [welcomeMessage],
    members: __spreadArray([], smartChatMembers, true),
    isTimedout: false,
    timerValue: -1,
    messageToBot: '',
    phoneNumber: '',
    code: '',
    email: '',
    firstName: '',
    checkpoint: SmartCheckpoint.ON_PHONE_NUMBER_VALIDATION_CHECK,
    previousCheckpoint: SmartCheckpoint.ON_PHONE_NUMBER_VALIDATION_CHECK,
    isFatalError: false,
    contantUs: false,
    showSendCodeAction: false,
    showChangePhoneAction: false,
    leadId: undefined,
};
export var initialAuthState = {
    status: Status.Unauthenticated,
    sendingCode: false,
    verifyingCode: false,
    verifiedCode: false,
    error: null,
};
//# sourceMappingURL=index.js.map